import {
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Box,
  Text,
  Link,
} from '@chakra-ui/react';
// import { CONNEXION_PATH } from 'lib/paths';
// import { accessSSO } from 'lib/sso';

const A1ConnectEmailCheckModal = ({
  isOpen,
  onClose,
  currentEmail,
  onSubmit,
}) => {
  const handleEmailValidatedByUser = () => {
    onSubmit();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody textAlign={'center'} p={8}>
          <Heading size="md">Juste une petite vérification 🤓</Heading>
          <Text>
            L'adresse email <b>{currentEmail}</b> n'est peut-être pas valide.
          </Text>
          <Box fontStyle="italic" mt={10}>
            <Text>
              <b>Pourquoi demande-t-on une adresse email valide ?</b>
            </Text>
            <Text>
              Dans l’intérêt des jeunes accompagnés par Article 1, il est
              nécessaire de fournir une adresse email valide pour bénéficier
              d’une expérience optimale.
            </Text>
          </Box>
          <Box>
            <Text>
              {' '}
              ⬅️{' '}
              <Link onClick={onClose}>
                Retourner à l’écran précédent et modifier l’adresse email
              </Link>
            </Text>
            <Text>ou</Text>
            {/* ci dessous : onClick => go to inscr via sso (skip mail page) */}
            <Text>
              <Link onClick={handleEmailValidatedByUser}>
                Continuer avec l’adresse {currentEmail}
              </Link>
            </Text>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default A1ConnectEmailCheckModal;
